import { z } from "zod";

export const vtGeneralSchema = z
  .object({
    address: z.string().optional(),
    plannedDate: z.string().optional(), // ISO yyyy-mm-dd
    projectAddressConfirmed: z.boolean().optional(),
    clientNom: z.string().optional(), // readonly from project_snapshot
    clientPrenom: z.string().optional(),
    clientEmail: z.string().optional(),
    autreGestionnaire: z.boolean().optional(),
    gestionnaireNom: z.string().optional(),
    gestionnairePrenom: z.string().optional(),
    gestionnaireTelephone: z.string().optional(),
    gestionnaireEmail: z.string().optional(),
    generalRemarks: z.string().optional(),
  })
  .partial();

export type VtGeneral = z.infer<typeof vtGeneralSchema>;
